import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'item' ]

  connect() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= 0.05) {
            this.element.classList.add('is-inview')
            this.itemTargets.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('is-inview')
              }, index * 100)
            })
            this.observer.unobserve(this.element)
          }
        })
      },
      { threshold: [0, 0.05, 0.1, 1] }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.unobserve(this.element)
    this.observer = null
    this.itemTargets.forEach(item => {
      item.classList.remove('is-inview')
    })
  }
}
